import React, { useState, useEffect, useRef } from "react";
import HomeNavbar from "../homepage/Navbar";
import {Footer} from "../../shared";
import axios from "axios";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { handleLoginPopup } from "../../redux/slice/userSlice";
import { toast } from "react-toastify";
import tenderbg from "../../assets/image/png/tenderr.png"; // your actual path
import { Header } from "../../shared";

const Taas = () => {
  const dispatch = useDispatch();
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    offeredPrice: "",
  });

  const categories = [
    "All Tenders",
    "Agri Drone Tenders",
    "Surveillance Drone Tenders",
    "Defense Drone Tenders",
    "Drone as a Service (DaaS) Tenders",
    "RPTO Drone Training Tenders",
    "Drone Parts Supply Tenders",
  ];
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [selectedCategory, setSelectedCategory] = useState("All Tenders");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortBy, setSortBy] = useState("recent");
  const [selectedTender, setSelectedTender] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const token = Cookies.get("token");
  const userId = Cookies.get("userId");
  const [searchQuery, setSearchQuery] = useState("");
  const [applicationStatuses, setApplicationStatuses] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [placeholder, setPlaceholder] = useState(
    "Search tenders by title, description or reference...",
  );

  useEffect(() => {
    const updatePlaceholder = () => {
      if (window.innerWidth <= 640) {
        // mobile (sm breakpoint in Tailwind)
        setPlaceholder("Search tenders");
      } else {
        setPlaceholder("Search tenders by title, description or reference...");
      }
    };

    updatePlaceholder(); // set on mount
    window.addEventListener("resize", updatePlaceholder);

    return () => window.removeEventListener("resize", updatePlaceholder);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch application statuses for the logged-in user
  useEffect(() => {
    if (userId) {
      const fetchApplicationStatuses = async () => {
        try {
          const response = await axios.get(
            process.env.REACT_APP_API_URL +
            `/getApplicationsByUserId/${userId}`,
          );
          const statusMap = {};
          response.data.data.forEach((app) => {
            statusMap[app.tenderId] = app.applicationStatus;
          });
          setApplicationStatuses(statusMap);
        } catch (err) {
          console.error("Error fetching application statuses:", err);
        }
      };
      fetchApplicationStatuses();
    }
  }, [userId]);

  const handleApply = async (e) => {
    e.preventDefault();

    if (!token) {
      dispatch(handleLoginPopup(true));
      toast.info("Please login to apply for tenders");
      return;
    }

    if (formData.phone.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    const userId = Cookies.get("userId");

    try {
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/taasApplicantDetail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            tenderId: selectedTender._id,
            userId: userId,
          }),
        },
      );

      const data = await res.json();
      if (res.ok) {
        toast.success("Application submitted successfully!");
        setFormData({ name: "", email: "", phone: "", offeredPrice: "" });
        setShowApplicationForm(false);
        setShowModal(false);

        // Update application status locally
        setApplicationStatuses((prev) => ({
          ...prev,
          [selectedTender._id]: "Pending",
        }));

        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 300);
      } else {
        toast.error(data.message || "Submission failed");
      }
    } catch (error) {
      console.error("Error submitting application:", error);
      toast.error("Something went wrong.");
    }
  };

  useEffect(() => {
    const fetchTenders = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/getFrontendTenders",
        );
        const formattedTenders = response.data.data.map((tender) => {
          let numericValue = 0;
          if (typeof tender.value === "string") {
            numericValue =
              parseFloat(tender.value.replace(/[^0-9.]/g, "")) || 0;
          } else if (typeof tender.value === "number") {
            numericValue = tender.value;
          }

          let formattedLocation = "Not specified";
          if (tender.location) {
            if (typeof tender.location === "object") {
              formattedLocation = [
                tender.location.city,
                tender.location.state,
                tender.location.pincode,
              ]
                .filter(Boolean)
                .join(", ");
            } else {
              formattedLocation = tender.location;
            }
          }

          let documentsRequired = [];
          if (tender.eligibilityCriteria) {
            if (Array.isArray(tender.eligibilityCriteria)) {
              documentsRequired = tender.eligibilityCriteria;
            } else if (typeof tender.eligibilityCriteria === "string") {
              documentsRequired = tender.eligibilityCriteria.split(",");
            }
          }

          const deadlineDate = new Date(tender.bidSubmissionDeadline);
          const today = new Date();
          const diffTime = deadlineDate - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          let timeRemaining = "";
          if (diffDays > 0) {
            timeRemaining = `${diffDays} day${diffDays !== 1 ? "s" : ""} left`;
          } else if (diffDays === 0) {
            timeRemaining = "Today";
          } else {
            timeRemaining = "Closed";
          }

          return {
            ...tender,
            title: tender.tenderServiceTitle,
            category: tender.tenderServiceType,
            description: tender.description,
            detailedDescription: tender.scope,
            deadline: tender.bidSubmissionDeadline,
            value:
              typeof tender.value === "string"
                ? tender.value
                : `₹${tender.value?.toLocaleString() || "0"}`,
            department: tender.department,
            reference: tender.tenderReferenceNumber,
            contactEmail: tender.tenderingAuthorityContact,
            documentsRequired,
            status:
              new Date(tender.bidSubmissionDeadline) > new Date()
                ? "open"
                : "closed",
            numericValue,
            formattedLocation,
            timeRemaining,
          };
        });
        setTenders(formattedTenders);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
        console.error("Error fetching tenders:", err);
      }
    };

    fetchTenders();
  }, []);

  const filteredTenders = tenders.filter((tender) => {
    const categoryMatch =
      selectedCategory === "All Tenders" ||
      tender.category === selectedCategory;
    const statusMatch =
      statusFilter === "all" || tender.status === statusFilter;
    const query = searchQuery.toLowerCase();
    const searchMatch =
      (tender.title || "").toLowerCase().includes(query) ||
      (tender.description || "").toLowerCase().includes(query) ||
      (tender.reference || "").toLowerCase().includes(query);
    return categoryMatch && statusMatch && searchMatch;
  });

  const sortedTenders = [...filteredTenders].sort((a, b) => {
    if (sortBy === "recent") {
      return new Date(b.deadline) - new Date(a.deadline);
    } else if (sortBy === "value-high") {
      return b.numericValue - a.numericValue;
    } else if (sortBy === "value-low") {
      return a.numericValue - b.numericValue;
    }
    return 0;
  });

  const openTenderDetails = (tender) => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      toast.info("Please login to view tender details");
      return;
    }
    try {
      setSelectedTender(tender);
      setShowModal(true);
    } catch (error) {
      console.error("Error opening tender details:", error);
    }
  };
  const handleDownloadDocument = async (documentUrl, tenderTitle, tenderId) => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      toast.info("Please login to download tender documents");
      return;
    }

    const status = applicationStatuses[tenderId];

    if (status !== "Accepted") {
      toast.error("You can only download documents for approved tenders");
      return;
    }

    try {
      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = documentUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";

      // Suggest a filename based on the tender title
      const fileName = `${tenderTitle.replace(/[^a-z0-9]/gi, "_").toLowerCase()}_document.pdf`;
      link.download = fileName;

      // Trigger the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Document download started");
    } catch (error) {
      console.error("Error downloading document:", error);
      toast.error("Failed to download document");
    }
  };
  const closeModal = () => {
    setShowModal(false);
    setSelectedTender(null);
    setShowApplicationForm(false);
    setFormData({ name: "", email: "", phone: "", offeredPrice: "" });
  };

  const handleApplyButtonClick = () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      toast.info("Please login to apply for this tender");
      return;
    }
    setShowApplicationForm(true);
  };

  // Helper function to check if sensitive info should be blurred
  const shouldBlurSensitiveInfo = (tenderId) => {
    if (!userId) return true; // Blur if not logged in
    const status = applicationStatuses[tenderId];
    return status !== "Accepted"; // Only show if status is exactly 'Accepted'
  };

  // Blurred text component
  const BlurredText = ({ text, isBlurred, tenderId }) => {
    const status = applicationStatuses[tenderId];

    return isBlurred ? (
      <span className="relative group select-none cursor-not-allowed inline-block">
        <span className="blur-sm bg-gray-200 rounded px-2 py-1 inline-block w-32 text-transparent">
          ******
        </span>
        <span className="absolute hidden group-hover:block z-10 w-64 p-2 text-xs text-white bg-gray-800 rounded shadow-lg left-1/2 transform -translate-x-1/2 -top-10 text-center">
          {!userId
            ? "Please login to view this information"
            : status === "Pending"
              ? "Your application is pending approval"
              : status === "Rejected"
                ? "Your application was rejected"
                : "Apply to view this information"}
        </span>
      </span>
    ) : (
      <span className="select-text">{text}</span>
    );
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-600 mx-auto"></div>
            <p className="mt-6 text-lg text-gray-600 font-medium">
              Loading tenders...
            </p>
            <p className="mt-2 text-gray-500">
              Please wait while we fetch the latest opportunities
            </p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
          <div className="text-center p-8 bg-white rounded-xl shadow-lg max-w-md">
            <div className="inline-flex items-center justify-center bg-red-100 rounded-full p-4 mb-4">
              <svg
                className="h-12 w-12 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Error loading tenders
            </h3>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-medium rounded-lg hover:opacity-90 transition-opacity shadow-md"
            >
              Try Again
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      {/* Hero Section */}

      <div
        className="relative text-white py-16 md:py-24 bg-cover bg-center"
        style={{
          backgroundImage: `url(${tenderbg})`,
        }}
      >
        {/* Blur overlay */}
        <div className="absolute inset-0 backdrop-blur-sm bg-teal/30"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white drop-shadow-lg">
              Discover Drone Tenders
            </h1>
            <p className="text-xl text-white mb-10 max-w-2xl mx-auto drop-shadow-xl backdrop-blur-lg rounded-lg">
              Find and apply for drone-related tenders from government and
              private sectors. Streamline your bidding process with our
              comprehensive tender management platform.
            </p>

            <div className="drop-shadow-xl backdrop-blur-lg rounded-full p-1 max-w-xl mx-auto mb-10 bg-white/20">
              <div className="flex">
                <input
                  type="text"
                  placeholder={placeholder}
                  className="w-full px-4 py-2 rounded-l-full focus:outline-none border-none outline-none text-white placeholder-white text-sm bg-transparent"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />

                <button className="bg-gradient-to-r from-blue-600 to-indigo-700 border-none text-white px-6 py-2 rounded-r-full font-medium hover:opacity-90 transition-opacity text-sm">
                  Search
                </button>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-blue-800/20 backdrop-blur-lg rounded-lg px-6 py-3">
                <span className="text-2xl font-bold">{tenders.length}</span>
                <p className="text-blue-100">Total Tenders</p>
              </div>
              <div className="bg-blue-800/20 backdrop-blur-lg rounded-lg px-6 py-3">
                <span className="text-2xl font-bold">
                  {tenders.filter((t) => t.status === "open").length}
                </span>
                <p className="text-blue-100">Active Tenders</p>
              </div>
              <div className="bg-blue-800/20 backdrop-blur-lg rounded-lg px-6 py-3">
                <span className="text-2xl font-bold">
                  ₹
                  {(
                    tenders.reduce((sum, t) => sum + t.numericValue, 0) /
                    10000000
                  ).toFixed(1)}
                  Cr+
                </span>
                <p className="text-blue-100">Total Value</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-12">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  Tender Categories
                </h2>
                <p className="text-gray-600">
                  Filter tenders by category to find the most relevant
                  opportunities
                </p>
              </div>

              <div className="flex flex-wrap gap-3 mt-4 lg:mt-0">
                <div className="flex flex-col">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="border border-gray-300 rounded-lg px-4 py-2 text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="all">All Status</option>
                    <option value="open">Open</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
                <div className="flex flex-col">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Sort By
                  </label>
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="border border-gray-300 rounded-lg px-4 py-2 text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="recent">Most Recent</option>
                    <option value="value-high">Highest Value</option>
                    <option value="value-low">Lowest Value</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Updated Categories Section - Dropdown for mobile, buttons for desktop */}
            {isMobile ? (
              <div className="mb-8">
                <label
                  htmlFor="category-select"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Select Category
                </label>
                <select
                  id="category-select"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {categories.map((category, index) => (
                    <option key={index} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="flex flex-wrap gap-2 mb-8">
                {categories.map((category, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${selectedCategory === category
                      ? "bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-md"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            )}

            <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2 mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-800">
                {selectedCategory === "All Tenders"
                  ? "All Tenders"
                  : selectedCategory}
                <span className="text-sm md:text-base font-normal text-gray-500 ml-1 md:ml-2">
                  ({filteredTenders.length} tenders)
                </span>
              </h2>

              <div className="text-sm text-gray-500">
                Showing {Math.min(sortedTenders.length, 12)} of{" "}
                {filteredTenders.length} results
              </div>
            </div>

            {sortedTenders.length === 0 ? (
              <div className="bg-gray-50 p-12 rounded-xl text-center">
                <div className="inline-flex items-center justify-center bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full p-6 mb-6">
                  <svg
                    className="h-16 w-16 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  No tenders found
                </h3>
                <p className="text-gray-600 max-w-md mx-auto mb-6">
                  {selectedCategory !== "All Tenders" ||
                    statusFilter !== "all" ||
                    searchQuery
                    ? "Try changing your filters or search query"
                    : "There are currently no tenders available. Please check back later."}
                </p>
                <button
                  onClick={() => {
                    setSelectedCategory("All Tenders");
                    setStatusFilter("all");
                    setSearchQuery("");
                  }}
                  className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-medium rounded-lg hover:opacity-90 transition-opacity"
                >
                  Reset Filters
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {sortedTenders.map((tender) => (
                  <div
                    key={tender._id || tender.id}
                    onClick={() => openTenderDetails(tender)}
                    className="flex flex-col justify-between bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-200 relative cursor-pointer overflow-hidden group"
                  >
                    <div
                      className={`absolute top-0 left-0 w-1.5 h-full ${tender.status === "closed"
                        ? "bg-red-500"
                        : "bg-green-500"
                        }`}
                    ></div>

                    <div className="p-6 bg-gradient-to-br from-gray-50 to-white grow">
                      <div className="flex justify-between items-start mb-4">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-medium ${tender.status === "closed"
                            ? "bg-red-100 text-red-800"
                            : "bg-green-100 text-green-800"
                            }`}
                        >
                          {tender.status === "closed"
                            ? "Closed"
                            : tender.timeRemaining}
                        </span>
                        <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
                          {tender.category}
                        </span>
                      </div>

                      <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-700 transition-colors">
                        {tender.title}
                      </h3>

                      <p className="text-gray-600 text-sm mb-6 line-clamp-2">
                        {tender.description}
                      </p>

                      {/* Aligned Deadline and Value headings horizontally */}
                      <div className="flex justify-between items-start border-t border-gray-100 pt-4">
                        <div className="text-left">
                          <p className="text-sm text-gray-500 font-semibold mb-1">
                            Deadline
                          </p>
                          <p className="text-sm font-medium">
                            {new Date(tender.deadline).toLocaleDateString()}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-500 font-semibold mb-1">
                            Value
                          </p>
                          <p className="text-lg font-bold text-green-600">
                            {tender.value}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-100 border-t px-4 py-2 flex justify-between items-center mt-auto">
                      {/* Location */}
                      <div className="flex items-center text-sm text-gray-700 overflow-hidden">
                        <svg
                          className="h-4 w-4 text-gray-500 mr-1 flex-shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                        <span
                          className="truncate max-w-[140px]"
                          title={tender.formattedLocation}
                        >
                          {tender.formattedLocation}
                        </span>
                      </div>

                      {/* Buttons */}
                      <div className="flex space-x-2">
                        {/* Download Button */}
                        {tender.document && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownloadDocument(
                                tender.document,
                                tender.title,
                                tender._id,
                              );
                            }}
                            className={`text-xs font-medium px-3 py-1 h-8 rounded-full shadow transition-all duration-200 flex items-center ${applicationStatuses[tender._id] === "Accepted"
                              ? "bg-green-600 text-white hover:opacity-90"
                              : "bg-gray-300 text-gray-500 cursor-not-allowed"
                              }`}
                            title={
                              applicationStatuses[tender._id] === "Accepted"
                                ? "Download Documents"
                                : "Documents available only for approved applications"
                            }
                          >
                            <svg
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                              />
                            </svg>
                          </button>
                        )}

                        {/* View Details Button */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            openTenderDetails(tender);
                          }}
                          className="text-xs font-medium bg-indigo-600 text-white px-3 py-1 h-8 rounded-full shadow hover:bg-indigo-700 transition-all duration-200 flex items-center"
                        >
                          View
                          <svg
                            className="h-4 w-4 ml-1"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal for tender details */}
      {showModal && selectedTender && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white rounded-xl shadow-xl max-w-3xl w-full max-h-[95vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 text-white">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-2xl font-bold line-clamp-2">
                    {selectedTender.tenderServiceTitle || selectedTender.title}
                  </h2>
                  <div className="flex items-center mt-2 space-x-2">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium ${selectedTender.status === "closed"
                        ? "bg-red-100 text-red-800"
                        : "bg-green-100 text-green-800"
                        }`}
                    >
                      {selectedTender.status === "closed"
                        ? "Closed"
                        : selectedTender.timeRemaining || "Open"}
                    </span>
                    <span className="px-3 py-1 bg-white/20 rounded-full text-xs font-medium">
                      {selectedTender.tenderServiceType ||
                        selectedTender.category}
                    </span>
                    {/* <span className="px-3 py-1 bg-white/20 rounded-full text-xs font-medium">
                {selectedTender.department}
              </span> */}
                  </div>
                </div>
                <button
                  onClick={closeModal}
                  className="text-white text-4xl font-bold leading-none hover:text-red-400 bg-transparent border-none shadow-none outline-none mt-[-20px] mr-[-10px]"
                  style={{ appearance: "none" }}
                  aria-label="Close"
                >
                  ×
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6 space-y-6">
              {/* Key Info Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Reference Number Card */}
                <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-100">
                  <div className="flex items-start">
                    <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                      <svg
                        className="h-5 w-5 text-indigo-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-indigo-600 font-medium">
                        Reference Number
                      </p>
                      <p className="text-sm font-bold text-gray-800 break-words ">
                        <BlurredText
                          text={selectedTender.tenderReferenceNumber}
                          isBlurred={shouldBlurSensitiveInfo(
                            selectedTender._id,
                          )}
                          tenderId={selectedTender._id}
                        />
                      </p>
                    </div>
                  </div>
                </div>

                {/* Tender Value Card - Highlighted with larger text */}
                <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100">
                  <div className="flex items-center">
                    <div className="bg-emerald-100 p-2 rounded-lg mr-3">
                      <svg
                        className="h-5 w-5 text-emerald-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <p className="text-xs text-emerald-600 font-medium">
                        Tender Value
                      </p>
                      <p className="text-lg font-bold text-gray-800">
                        {selectedTender.value?.toLocaleString("en-IN")}
                        {selectedTender.valueCurrency && (
                          <span className="text-sm font-normal ml-1">
                            ({selectedTender.valueCurrency})
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Deadline Card */}
                <div className="bg-purple-50 p-4 rounded-lg border border-purple-100">
                  <div className="flex items-center">
                    <div className="bg-purple-100 p-2 rounded-lg mr-3">
                      <svg
                        className="h-5 w-5 text-purple-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <p className="text-xs text-purple-600 font-medium">
                        Deadline
                      </p>
                      <p className="text-sm font-bold text-gray-800">
                        {new Date(
                          selectedTender.bidSubmissionDeadline ||
                          selectedTender.deadline,
                        ).toLocaleDateString()}
                        <br />
                        {new Date(
                          selectedTender.bidSubmissionDeadline ||
                          selectedTender.deadline,
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Description Section */}
              <div className="space-y-4">
                <div className="border-b border-gray-200 pb-2">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Tender Details
                  </h3>
                </div>

                {selectedTender.description && (
                  <div>
                    <h4 className="text-sm font-medium text-gray-500 mb-1">
                      Description
                    </h4>
                    <p className="text-gray-700">
                      {selectedTender.description}
                    </p>
                  </div>
                )}

                {selectedTender.scope && (
                  <div>
                    <h4 className="text-sm font-medium text-gray-500 mb-1">
                      Scope of Work
                    </h4>
                    <div
                      className="text-gray-700 prose"
                      dangerouslySetInnerHTML={{ __html: selectedTender.scope }}
                    />
                  </div>
                )}
              </div>

              {/* Additional Details */}
              <div className="space-y-4">
                <div className="border-b border-gray-200 pb-2">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Additional Information
                  </h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      EMD Amount
                    </p>
                    <p className="font-medium">
                      ₹{selectedTender.EMD?.toLocaleString("en-IN")}
                      {selectedTender.emdCurrency && (
                        <span className="text-xs text-gray-500 ml-1">
                          ({selectedTender.emdCurrency})
                        </span>
                      )}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      Issuing Authority
                    </p>
                    <p className="font-medium">
                      <BlurredText
                        text={selectedTender.issuingAuthority}
                        isBlurred={shouldBlurSensitiveInfo(selectedTender._id)}
                        tenderId={selectedTender._id}
                      />
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      Contact Information
                    </p>
                    <p className="font-medium">
                      <BlurredText
                        text={selectedTender.tenderingAuthorityContact}
                        isBlurred={shouldBlurSensitiveInfo(selectedTender._id)}
                        tenderId={selectedTender._id}
                      />
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      Location
                    </p>
                    <p className="font-medium">
                      {selectedTender.formattedLocation}
                    </p>
                  </div>
                </div>
              </div>

              {/* Important Dates */}
              <div className="space-y-4">
                <div className="border-b border-gray-200 pb-2">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Important Dates
                  </h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      Bid Submission Deadline
                    </p>
                    <p className="font-medium">
                      {new Date(
                        selectedTender.bidSubmissionDeadline,
                      ).toLocaleDateString()}{" "}
                      at{" "}
                      {new Date(
                        selectedTender.bidSubmissionDeadline,
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </p>
                  </div>
                  {selectedTender.preBidMeetingDate && (
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Pre-Bid Meeting Date
                      </p>
                      <p className="font-medium">
                        {new Date(
                          selectedTender.preBidMeetingDate,
                        ).toLocaleDateString()}
                      </p>
                    </div>
                  )}
                  {selectedTender.purchaseEndDate && (
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Document Purchase End
                      </p>
                      <p className="font-medium">
                        {new Date(
                          selectedTender.purchaseEndDate,
                        ).toLocaleDateString()}
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* Document Download Section */}
              {selectedTender.document && (
                <div className="space-y-4">
                  <div className="border-b border-gray-200 pb-2">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Tender Documents
                    </h3>
                  </div>
                  <button
                    onClick={() =>
                      handleDownloadDocument(
                        selectedTender.document,
                        selectedTender.title,
                        selectedTender._id,
                      )
                    }
                    className={`px-4 py-2 rounded-md flex items-center space-x-2 ${applicationStatuses[selectedTender._id] === "Accepted"
                      ? "bg-green-600 text-white hover:bg-green-700"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={
                      applicationStatuses[selectedTender._id] !== "Accepted"
                    }
                  >
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    <span>Download Tender Documents</span>
                  </button>
                  {applicationStatuses[selectedTender._id] !== "Accepted" && (
                    <p className="text-sm text-gray-500">
                      {applicationStatuses[selectedTender._id] === "Pending"
                        ? "Your application is pending approval. Documents will be available once approved."
                        : applicationStatuses[selectedTender._id] === "Rejected"
                          ? "Your application was rejected. Contact support for more information."
                          : "Please apply and get approved to access the documents."}
                    </p>
                  )}
                </div>
              )}

              {/* Application Form */}
              {selectedTender.status === "open" && (
                <>
                  {!showApplicationForm ? (
                    <div className="pt-4">
                      <button
                        onClick={handleApplyButtonClick}
                        className={`w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:opacity-90 text-white font-medium py-3 px-4 rounded-lg transition-opacity flex items-center justify-center space-x-2 ${applicationStatuses[selectedTender._id]
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                          }`}
                        disabled={!!applicationStatuses[selectedTender._id]}
                      >
                        {applicationStatuses[selectedTender._id] ? (
                          <>
                            <svg
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            <span>
                              {applicationStatuses[selectedTender._id] ===
                                "Pending"
                                ? "Application Submitted"
                                : "Application " +
                                applicationStatuses[selectedTender._id]}
                            </span>
                          </>
                        ) : (
                          <>
                            <svg
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span>Apply for This Tender</span>
                          </>
                        )}
                      </button>
                    </div>
                  ) : (
                    <div
                      ref={formRef}
                      className="bg-gray-50 mt-4 p-6 rounded-lg border border-gray-200"
                    >
                      <div className="mb-6">
                        <h3 className="text-lg font-semibold text-gray-800">
                          Application Form
                        </h3>
                        <p className="text-sm text-gray-500">
                          Fill in your details to apply
                        </p>
                      </div>

                      <form onSubmit={handleApply} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Full Name
                            </label>
                            <input
                              type="text"
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                              value={formData.name}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  name: e.target.value,
                                })
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Email
                            </label>
                            <input
                              type="email"
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                              value={formData.email}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  email: e.target.value,
                                })
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Phone Number
                            </label>
                            <input
                              type="tel"
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                              value={formData.phone}
                              onChange={(e) => {
                                const value = e.target.value
                                  .replace(/\D/g, "")
                                  .slice(0, 10);
                                setFormData({ ...formData, phone: value });
                              }}
                              pattern="[0-9]{10}"
                              inputMode="numeric"
                              required
                            />
                            {formData.phone.length !== 10 &&
                              formData.phone.length > 0 && (
                                <p className="mt-1 text-xs text-red-600">
                                  Please enter a valid 10-digit phone number
                                </p>
                              )}
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Offered Price (₹)
                            </label>
                            <div className="relative">
                              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">
                                ₹
                              </span>
                              <input
                                type="number"
                                className="w-full pl-8 px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                value={formData.offeredPrice}
                                onChange={(e) => {
                                  const value = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  );
                                  setFormData({
                                    ...formData,
                                    offeredPrice: value,
                                  });
                                }}
                                min="0"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-end space-x-3 pt-4">
                          <button
                            type="button"
                            onClick={() => setShowApplicationForm(false)}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            disabled={formData.phone.length !== 10}
                            className={`px-4 py-2 text-sm font-medium text-white rounded-md ${formData.phone.length !== 10
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-blue-600 hover:bg-blue-700"
                              }`}
                          >
                            Submit Application
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Taas;
